
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 1.002c1.629.002 3.129.302 3.129.302l-.79 2.187v1.215l-.729.486V14H5.89V5.192l-.729-.486V3.491l-.79-2.187s1.5-.3 3.129-.302L7.47 1h.06l-.03.002zm-2.696.507l.609 1.857.796-.124L5.853 1.4l-1.049.109zm4.33-.149l-.152 1.795.711.143.534-1.798-1.093-.14zm-2.948.02l.302 1.82.932-.134-.05-1.771-1.184.085zm1.545-.091v1.756l.999.075.087-1.795-1.086-.036z"}})])
          )
        }
      }
    